import { render, staticRenderFns } from "./DepositAccountCard.vue?vue&type=template&id=7a74bf95&scoped=true&"
import script from "./DepositAccountCard.vue?vue&type=script&lang=js&"
export * from "./DepositAccountCard.vue?vue&type=script&lang=js&"
import style0 from "./DepositAccountCard.vue?vue&type=style&index=0&id=7a74bf95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74bf95",
  null
  
)

export default component.exports